module.exports = __webpack_public_path__ + "static/instagram-01b57e82bc04736879495ef2f01f32a9.png";